import React from 'react';
import { motion } from 'framer-motion';
import { MoonIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const COVER = 'https://cdn.magicpatterns.com/uploads/krjkWXMhN4jKdhLjworVSd/Portada.png';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-33">
      {/* ambient glows */}
      <div className="pointer-events-none absolute -left-40 top-10 h-96 w-96 rounded-full bg-rose-glow/20 blur-[120px]" data-id="element-34" />
      <div className="pointer-events-none absolute -right-40 top-40 h-96 w-96 rounded-full bg-electric/20 blur-[130px]" data-id="element-35" />

      <div className="relative mx-auto grid max-w-6xl grid-cols-1 items-center gap-14 px-6 py-20 lg:grid-cols-2 lg:py-28" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-37">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.2em] text-muted" data-id="element-38">
            <MoonIcon className="h-3.5 w-3.5 text-electric" data-id="element-39" />
            eBook · Duelo de los "casi algo"
          </span>

          <h1 className="mt-6 font-display text-4xl font-semibold leading-[1.08] text-cream sm:text-5xl lg:text-6xl" data-id="element-40">
            El Mapa de los{' '}
            <span className="italic text-rose-glow" data-id="element-41">"Casi Algo"</span>
          </h1>
          <p className="mt-4 font-display text-xl italic text-muted sm:text-2xl" data-id="element-42">
            El Protocolo para Sanar lo que "No Fue Nada" (pero dolió como todo).
          </p>

          <h2 className="mt-6 max-w-lg text-base leading-relaxed text-muted sm:text-lg" data-id="element-43">
            Deja de buscar respuestas en el silencio de quien te dejó vacío y
            recupera tu centro en{' '}
            <span className="font-semibold text-cream" data-id="element-44">menos de 21 días</span>.
          </h2>

          <div className="mt-9 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-45">
            <CTAButton data-id="element-46" />
            <span className="text-sm text-muted" data-id="element-47">
              Precio único{' '}
              <span className="font-semibold text-cream" data-id="element-48">$6.39 USD</span> ·
              Descarga instantánea
            </span>
          </div>
        </motion.div>

        <motion.div className="relative mx-auto w-full max-w-md" initial={{
        opacity: 0,
        scale: 0.94,
        rotate: -2
      }} animate={{
        opacity: 1,
        scale: 1,
        rotate: 0
      }} transition={{
        duration: 0.9,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-49">
          <div className="absolute inset-0 -z-10 translate-y-6 scale-95 rounded-3xl bg-rose-glow/30 blur-3xl" data-id="element-50" />
          <img src={COVER} alt="Portada del eBook El Mapa de los Casi Algo, cómo cerrar el ciclo" className="w-full rounded-2xl border border-white/10 shadow-2xl" data-id="element-51" />
        </motion.div>
      </div>
    </header>;
}